export function OutlineCalendarIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 9.99805H21V19.0028C21 20.1068 20.1072 20.9996 19.0032 20.9996H4.9968C3.8928 20.9996 3 20.1068 3 19.0028V9.99805Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
      <path d="M12 12.5V14.5016" stroke={stroke} strokeWidth={strokeWidth} strokeLinejoin="round" />
      <path
        d="M6.99854 16.498V18.4996"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
      <path
        d="M17.0015 16.498V18.4996"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
      <path
        d="M12 16.498V18.4996"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
      <path
        d="M17.0015 12.5V14.5016"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
      <path
        d="M4.9968 5.00195H19.0032C20.1072 5.00195 21 5.89475 21 6.99875V10.0035H3V6.99875C3 5.89475 3.8928 5.00195 4.9968 5.00195Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
      <path
        d="M6.99854 6.99839V3"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
      <path
        d="M17.0015 6.99839V3"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
    </svg>
  );
}
